import React from 'react'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import { useTranslation } from 'react-i18next'
import Typography from '@material-ui/core/Typography'
import { PrimaryCheckbox } from 'components/Shared/PrimaryCheckbox'
import { AvenirRegular } from 'styles/variables'
import { isUndefined } from 'lodash'
import makeStyles from "@material-ui/core/styles/makeStyles";

const useStyles = makeStyles({
  root: {
    maxWidth: 308
  }
})
export function ReadOnlyCheckbox ({ label, checked = true , diffValue}) {
  const { t } = useTranslation()
  const displayedDiffValue = (!isUndefined(diffValue) && diffValue !== checked) ? diffValue : undefined
  const classes = useStyles()

  return (
    <FormControlLabel
      classes={{
        root: classes.root,
      }}
      control={
        <PrimaryCheckbox
          checked={checked}
          diffValue={displayedDiffValue}
          disabled
        />
      }
      label={<Typography style={{ fontFamily: AvenirRegular }}>{t(label)}</Typography>}
    />
  )
}
